import { SpriteRoutes } from "./Sprite/routes";
import { FlarieRoutes } from "./FlarieGames/routes";
// import { DellRoutes } from "./Dell/routes";
import { ThumsupRoutes } from "./Thumsup/routes";
import { NipponRoutes } from "./Nippon/routes";
// import { MadburyRoutes } from "./Madbury/routes";
import { SaffolaRoutes } from "./Saffola/routes";
import { BlsRoutes } from "./DpandaBls/routes";
import { HSBCRoutes } from "./HSBC/routes";
import { TCRoutes } from "./TCAudienceSurvey/routes";
import { MahindraVistaRoutes } from "./MahindraVista/routes";
import { GodrejRoutes } from "./Godrej/routes";
import { IndixitalRoutes } from "./ClubMahidraIndixital/routes";
import { UpgradAimlRoutes } from "./UpgradAiMl/routes";
import { OfferWallRoutes } from "./OfferWall/routes";
import ExternalRedirect from "../components/ExternalRedirect.vue";

// CadburyRoutes and MadburyRoutes are created for POC
export const LeadClientRoutes = [
  ...FlarieRoutes,
  // ...DellRoutes,
  ...SpriteRoutes,
  ...NipponRoutes,
  ...ThumsupRoutes,
  ...SaffolaRoutes,
  ...BlsRoutes,
  ...HSBCRoutes,
  ...TCRoutes,
  ...MahindraVistaRoutes,
  ...GodrejRoutes,
  ...IndixitalRoutes,
  ...UpgradAimlRoutes,
  ...OfferWallRoutes,
  // External media redirect pages
  {
    path: "/media/84e3e4a7-bae1-41a2-a11f-5c6b5331e775",
    name: "media-84e3e4a7",
    component: ExternalRedirect,
    props: {
      target: "https://ads-media.truecaller.com/84e3e4a7-bae1-41a2-a11f-5c6b5331e775"
    },
    meta: { title: "Truecaller" }
  },
  {
    path: "/media/c0043cd0-de43-482d-a637-5e9bc63d5c24",
    name: "media-c0043cd0",
    component: ExternalRedirect,
    props: {
      target: "https://ads-media.truecaller.com/c0043cd0-de43-482d-a637-5e9bc63d5c24"
    },
    meta: { title: "Truecaller" }
  },
  {
    path: "/media/165f2e42-b08f-4f8f-95a0-21fbd3270081",
    name: "media-165f2e42",
    component: ExternalRedirect,
    props: {
      target: "https://ads-media.truecaller.com/165f2e42-b08f-4f8f-95a0-21fbd3270081"
    },
    meta: { title: "Truecaller" }
  },
  {
    path: "/media/a6c8fce4-7912-41d1-b4f5-99c2f7392b10",
    name: "media-a6c8fce4",
    component: ExternalRedirect,
    props: {
      target: "https://ads-media.truecaller.com/a6c8fce4-7912-41d1-b4f5-99c2f7392b10"
    },
    meta: { title: "Truecaller" }
  }
];
